import { observable, computed, toJS } from 'mobx';
import { autobind } from 'core-decorators';

import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { noop } from '@src/utils/common-util';
import Video from '@src/components/video';
import $$tracker from '@src/tracker';
import { useEffect } from 'react';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import useMount from '@src/utils/hooks/use-mount';

class AudioListStore {
  videoImageSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      autoplay: false
    }
  });
  paginationSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true
    }
  });

  onSelect = noop;

  // 视频列表
  @observable videoList = [];
  // 当前选中的视频索引
  @observable activeIndex = 0;
  // @computed
  // get activeIndex() {
  //   return this.paginationSwiperStore.activeIndex;
  // }
  // 当前选中的视频
  @computed
  get activeVideo() {
    return this.videoList[this.activeIndex];
  }

  @autobind
  select(index) {
    if (this.activeIndex !== index) {
      this.onSelect(toJS(this.activeVideo), index);
    }
  }

  @autobind
  prevVideo() {
    this.paginationSwiperStore.goPrev();
  }

  @autobind
  nextVideo() {
    this.paginationSwiperStore.goNext();
  }

  @autobind
  playVideo() {
    $$tracker.clickStzxPlayVideo(this.activeVideo?.title);
    const { close } = Video.append({ src: this.activeVideo?.video || '' });
    this.cleanVideoUp = close;
  }

  constructor(props = {}) {
    Object.assign(this, props);
    this.onSelect = props.onSelect || noop;
  }

  use() {
    useEffect(
      () => {
        if (this.activeVideo) {
          $$tracker.clickStzxVideo(this.activeVideo?.title);
        }
      },
      [this.activeVideo]
    );

    // useEffect(
    //   () => {
    //     // 当activeIndex变化时，同步两个swiper
    //     this.paginationSwiperStore.onChange(this.activeIndex);
    //     this.videoImageSwiperStore.onChange(this.activeIndex);
    //   },
    //   [this.activeIndex]
    // );
    useEffect(
      () => {
        this.activeIndex = this.videoImageSwiperStore.activeIndex;
        this.paginationSwiperStore.onChange(this.activeIndex);
      },
      [this.videoImageSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.activeIndex = this.paginationSwiperStore.activeIndex;
        this.videoImageSwiperStore.onChange(this.activeIndex);
      },
      [this.paginationSwiperStore.activeIndex]
    );
  }
}

export default AudioListStore;
